import * as React from 'react';

import UndeliverableModalGraphicSVG from './undeliverable-modal-graphic.svg';

import styles from './message-modal-graphic.module.css';

export function UndeliverableModalGraphic() {
    return (
        <div className={styles.container}>
            <UndeliverableModalGraphicSVG width={152} />
        </div>
    );
}
